import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import ApiClient from "../../methods/api/apiClient";
import { toast } from "react-toastify";
import loader from "../../methods/loader";
import Layout2 from "../../components/global/layout2";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

var statusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "draft", label: "Draft" },
];

var templateVariables = [
  "carrier_name",
  "mc_number",
  "dot_number",
  "address",
  "date",
  "effective_date",
  "expiry_date",
  "payment_terms",
];

var quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link", "image"],
    ["clean"],
  ],
};

var quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "list",
  "bullet",
  "align",
  "link",
  "image",
];

var AddEditAgreementTemplate = function () {
  var params = useParams();
  var id = params.id;
  var historyHook = useHistory();
  var quillRef = useRef(null);

  // If id is "add", it's creating, not editing
  var isEdit = id && id !== "add";

  var formState = useState({
    name: "",
    version: "1.0",
    body_html: "",
    status: "draft",
  });
  var form = formState[0];
  var setform = formState[1];

  var previewState = useState("");
  var previewHtml = previewState[0];
  var setPreviewHtml = previewState[1];

  var showPreviewState = useState(false);
  var showPreview = showPreviewState[0];
  var setShowPreview = showPreviewState[1];

  // Load template data in edit mode
  useEffect(function () {
    if (isEdit) {
      loader(true);
      ApiClient.get("carrier-agreement-template", { id: id }).then(function (res) {
        if (res.success && res.data) {
          var d = res.data;
          setform({
            name: d.name || "",
            version: d.version || "1.0",
            body_html: d.body_html || "",
            status: d.status || "draft",
          });
        }
        loader(false);
      });
    }
  }, [id]);

  var handleSubmit = function (e) {
    e.preventDefault();
    if (!form.name.trim()) {
      toast.error("Template name is required");
      return;
    }
    if (!form.body_html.trim() || form.body_html === "<p><br></p>") {
      toast.error("Agreement body is required");
      return;
    }

    loader(true);
    var payload = { ...form };

    if (isEdit) {
      payload.id = id;
      ApiClient.put("carrier-agreement-template", payload).then(function (res) {
        if (res.success) {
          toast.success("Template updated successfully");
          historyHook.push("/agreement-templates");
        }
        loader(false);
      });
    } else {
      ApiClient.post("carrier-agreement-template", payload).then(function (res) {
        if (res.success) {
          toast.success("Template created successfully");
          historyHook.push("/agreement-templates");
        }
        loader(false);
      });
    }
  };

  var insertVariable = useCallback(
    function (varName) {
      var quill = quillRef.current ? quillRef.current.getEditor() : null;
      if (quill) {
        var range = quill.getSelection(true);
        var position = range ? range.index : quill.getLength() - 1;
        quill.insertText(position, "{{" + varName + "}}");
        quill.setSelection(position + varName.length + 4);
      }
    },
    []
  );

  var handlePreview = function () {
    var html = form.body_html;
    templateVariables.forEach(function (v) {
      var regex = new RegExp("\\{\\{" + v + "\\}\\}", "g");
      html = html.replace(
        regex,
        '<span style="background:#fff3cd;padding:1px 4px;border-radius:3px;">[' +
          v.replace(/_/g, " ") +
          "]</span>"
      );
    });
    setPreviewHtml(html);
    setShowPreview(true);
  };

  return (
    <Layout2 title="Agreement Templates">
      <div className="mainareas">
        <form onSubmit={handleSubmit}>
          <div className="edit-page-common new-edit edit-page-commons">
            {/* Header */}
            <div className="row">
              <div className="col-lg-12">
                <div className="title-head">
                  <h3 className="ViewUser mb-0 user-back">
                    <Link to="/agreement-templates" className="">
                      <i
                        className="fa fa-arrow-left ml-1"
                        title="Back"
                        aria-hidden="true"
                      ></i>
                    </Link>
                    {isEdit ? "Edit" : "Add"} Agreement Template
                  </h3>
                </div>
              </div>
            </div>

            {/* Basic Details */}
            <div className="row pt-3">
              <div className="col-md-12">
                <div className="white-head mb-3">
                  <h5 className="profilelist">Template Details</h5>
                </div>
              </div>
              <div className="col-md-12">
                <div className="white-bg-main mb-4">
                  <div className="row">
                    <div className="col-md-5 mb-3">
                      <label>
                        Template Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={form.name}
                        required
                        placeholder="e.g. Standard Carrier-Broker Agreement"
                        onChange={function (e) {
                          setform({ ...form, name: e.target.value });
                        }}
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>Version</label>
                      <input
                        type="text"
                        className="form-control"
                        value={form.version}
                        placeholder="e.g. 1.0"
                        onChange={function (e) {
                          setform({ ...form, version: e.target.value });
                        }}
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>
                        Status<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={form.status}
                        onChange={function (e) {
                          setform({ ...form, status: e.target.value });
                        }}
                      >
                        {statusOptions.map(function (opt) {
                          return (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Variable Helper */}
            <div className="row">
              <div className="col-md-12">
                <div className="white-head mb-3">
                  <h5 className="profilelist">
                    Available Variables{" "}
                    <small style={{ fontWeight: 400, color: "#888" }}>
                      (click to insert at cursor)
                    </small>
                  </h5>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <div
                  className="white-bg-main"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                    padding: "16px",
                  }}
                >
                  {templateVariables.map(function (v) {
                    return (
                      <span
                        key={v}
                        onClick={function () { insertVariable(v); }}
                        style={{
                          display: "inline-block",
                          padding: "5px 12px",
                          backgroundColor: "#eef1f8",
                          border: "1px solid #d0d7e8",
                          borderRadius: "16px",
                          fontSize: "13px",
                          color: "#3E549D",
                          cursor: "pointer",
                          fontFamily: "monospace",
                          transition: "all 0.2s",
                          userSelect: "none",
                        }}
                        onMouseEnter={function (e) {
                          e.target.style.backgroundColor = "#3E549D";
                          e.target.style.color = "#fff";
                        }}
                        onMouseLeave={function (e) {
                          e.target.style.backgroundColor = "#eef1f8";
                          e.target.style.color = "#3E549D";
                        }}
                        title={"Click to insert {{" + v + "}}"}
                      >
                        {"{{" + v + "}}"}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Rich Text Editor */}
            <div className="row">
              <div className="col-md-12">
                <div className="white-head mb-3">
                  <h5 className="profilelist">
                    Agreement Body<span className="text-danger">*</span>
                  </h5>
                </div>
              </div>
              <div className="col-md-12 mb-4">
                <div className="white-bg-main" style={{ padding: "16px" }}>
                  <ReactQuill
                    ref={quillRef}
                    theme="snow"
                    value={form.body_html}
                    onChange={function (value) {
                      setform({ ...form, body_html: value });
                    }}
                    modules={quillModules}
                    formats={quillFormats}
                    style={{ minHeight: "300px" }}
                    placeholder="Compose your agreement template here..."
                  />
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handlePreview}
                >
                  <i className="fa fa-eye me-1"></i> Preview
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={function () { historyHook.push("/agreement-templates"); }}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  {isEdit ? "Update" : "Create"} Template
                </button>
              </div>
            </div>
          </div>
        </form>

        {/* Preview Modal */}
        {showPreview && (
          <div
            className="modal black-screen d-block"
            style={{ zIndex: 1050 }}
            onClick={function (e) {
              if (e.target === e.currentTarget) setShowPreview(false);
            }}
          >
            <div
              className="modal-dialog"
              style={{ maxWidth: "700px", marginTop: "5%" }}
            >
              <div className="modal-content">
                <div
                  className="modal-header"
                  style={{
                    borderBottom: "1px solid #eee",
                    padding: "16px 20px",
                  }}
                >
                  <h5 className="modal-title" style={{ fontWeight: 600 }}>
                    Agreement Preview
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={function () { setShowPreview(false); }}
                  ></button>
                </div>
                <div
                  className="modal-body"
                  style={{
                    padding: "20px",
                    maxHeight: "60vh",
                    overflowY: "auto",
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{ __html: previewHtml }}
                    style={{
                      border: "1px solid #eee",
                      borderRadius: "4px",
                      padding: "20px",
                      backgroundColor: "#fff",
                    }}
                  ></div>
                </div>
                <div
                  className="modal-footer"
                  style={{
                    borderTop: "1px solid #eee",
                    padding: "12px 20px",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={function () { setShowPreview(false); }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout2>
  );
};

export default AddEditAgreementTemplate;
